// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__EXSrD","sidebar__list":"Sidebar_sidebar__list__qyKQ2","sidebar__link":"Sidebar_sidebar__link__xAWit"};